import {
  FaUniversity,
  FaCreditCard,
  FaHandsHelping,
  FaHome,
  FaGraduationCap,
  FaShoppingCart,
} from "react-icons/fa";

// Single source of truth for the Industries section and the
// /industries/:slug detail page.
export const industries = [
  {
    slug: "banking-financial-services",
    title: "Banking & Financial Services",
    Icon: FaUniversity,
    description:
      "Supporting banking transformation, regulatory programmes, digital banking and customer experience initiatives.",
    overview:
      "We help banks and financial institutions navigate transformation, regulation, and digital disruption. From core modernization to customer experience, we deliver secure, compliant, and future-ready solutions that build trust and efficiency.",
    highlights: [
      "Digital banking & channel modernization",
      "Regulatory & compliance programmes",
      "Core banking system integration",
      "Fraud, risk & data governance",
      "Customer onboarding & experience",
      "Legacy modernization & migration",
    ],
    useCases: [
      "Delivering regulatory change programmes",
      "Launching digital banking channels",
      "Modernizing legacy core systems",
    ],
  },
  {
    slug: "payments",
    title: "Payments",
    Icon: FaCreditCard,
    description:
      "Delivering payment modernization, open banking, transaction processing and integration solutions.",
    overview:
      "The payments landscape is evolving fast. We deliver payment modernization, open banking, and real-time processing solutions that are secure, scalable, and compliant — helping you move money faster and safer.",
    highlights: [
      "Open banking & PSD2 integration",
      "Real-time & instant payments",
      "Payment gateway & scheme integration",
      "Transaction processing at scale",
      "PCI-DSS security & compliance",
      "Reconciliation & settlement",
    ],
    useCases: [
      "Enabling open banking connectivity",
      "Modernizing payment processing",
      "Integrating new payment schemes",
    ],
  },
  {
    slug: "non-profit",
    title: "Non-Profit Organisations",
    Icon: FaHandsHelping,
    description:
      "Helping charities and membership organizations improve operational efficiency and service delivery.",
    overview:
      "We help charities and membership organizations do more with less — improving operational efficiency, member engagement, and service delivery through practical, cost-effective technology and process improvements.",
    highlights: [
      "Membership & CRM systems",
      "Fundraising & donation platforms",
      "Volunteer & case management",
      "Process automation & efficiency",
      "Data insight & reporting",
      "Digital service delivery",
    ],
    useCases: [
      "Streamlining membership management",
      "Improving fundraising operations",
      "Automating manual admin processes",
    ],
  },
  {
    slug: "social-housing",
    title: "Social Housing",
    Icon: FaHome,
    description:
      "Providing digital transformation, tenant engagement and housing management solutions.",
    overview:
      "We support housing providers in transforming tenant services and operations. From self-service portals to housing management integration, we deliver solutions that improve tenant experience and operational efficiency.",
    highlights: [
      "Tenant self-service portals",
      "Housing management system integration",
      "Repairs & maintenance workflows",
      "Tenant engagement & communication",
      "Compliance & safety tracking",
      "Data & reporting dashboards",
    ],
    useCases: [
      "Launching tenant self-service portals",
      "Digitizing repairs and maintenance",
      "Improving tenant communication",
    ],
  },
  {
    slug: "education",
    title: "Education",
    Icon: FaGraduationCap,
    description:
      "Building learning platforms, student portals and modern educational technology solutions.",
    overview:
      "We build modern educational technology — from learning platforms to student portals — that improve engagement, accessibility, and administration for schools, colleges, and training providers.",
    highlights: [
      "Learning management platforms",
      "Student & parent portals",
      "Enrollment & admissions systems",
      "Virtual & blended learning tools",
      "Integration with education systems",
      "Analytics & progress tracking",
    ],
    useCases: [
      "Deploying learning management systems",
      "Building student self-service portals",
      "Modernizing admissions and enrollment",
    ],
  },
  {
    slug: "retail-ecommerce",
    title: "Retail & eCommerce",
    Icon: FaShoppingCart,
    description:
      "Enhancing customer engagement, online sales and digital commerce experiences.",
    overview:
      "We help retailers create seamless, engaging commerce experiences across channels. From storefronts to backend integration, we deliver scalable eCommerce solutions that drive sales and customer loyalty.",
    highlights: [
      "eCommerce storefront development",
      "Omnichannel customer experience",
      "Payment & checkout optimization",
      "Inventory & order management integration",
      "Personalization & marketing automation",
      "Analytics & conversion optimization",
    ],
    useCases: [
      "Building or replatforming online stores",
      "Unifying in-store and online experiences",
      "Optimizing checkout and conversion",
    ],
  },
];

export const getIndustry = (slug) =>
  industries.find((i) => i.slug === slug);
